class AbstractEntity {
  constructor (name = null, referent = null) {
    this.name = name
    this.referent = referent
  }

  static get boundaryClass () {
    throw new Error('not implemented')
  }

  static get ICON () {
    return 'users'
  }
}

export { AbstractEntity }
